import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './contact-us.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var ContactUs = /** @class */ (function (_super) {
    tslib_1.__extends(ContactUs, _super);
    function ContactUs(element) {
        return _super.call(this, element) || this;
    }
    ContactUs.prototype.init = function () {
        var _this = this;
        this.contactTitles = Array.from(this.element.querySelectorAll('.contact-us__items--box .js-contact-us-title'));
        this.contactTimes = Array.from(this.element.querySelectorAll('.contact-us__items--box .js-contact-us-times'));
        this.contactDetails = Array.from(this.element.querySelectorAll('.contact-us__items--box .js-contact-us-details'));
        setTimeout(function () {
            _this.equalHeights(_this.contactTitles);
            _this.equalHeights(_this.contactTimes);
            _this.equalHeights(_this.contactDetails);
        }, 100);
    };
    ContactUs.prototype.bindEvents = function () {
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('orientationchange', this.onResize.bind(this));
    };
    ContactUs.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.equalHeights(_this.contactTitles);
            _this.equalHeights(_this.contactTimes);
            _this.equalHeights(_this.contactDetails);
        }, 100);
    };
    ContactUs.prototype.equalHeights = function (elements) {
        this.defaultHeights(elements);
        if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
            var tallestElement = 0;
            for (var i = 0; i < elements.length; i++) {
                var el = elements[i];
                var elHeight = el.offsetHeight;
                if (elHeight > tallestElement) {
                    tallestElement = elHeight;
                }
            }
            for (var i = 0; i < elements.length; i++) {
                elements[i].style.height = tallestElement + "px";
            }
        }
    };
    ContactUs.prototype.defaultHeights = function (elements) {
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.height = 'auto';
        }
    };
    return ContactUs;
}(Base));
export { ContactUs };



//////////////////
// WEBPACK FOOTER
// ./components/contact-us/contact-us.component.ts
// module id = 213
// module chunks = 0